import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Inicio from '../views/Inicio.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: Inicio
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
